export const alertConstants = {
    SUCCESS: "ALERT_SUCCESS",
    ERROR: "ALERT_ERROR",
    CLEAR: "ALERT_CLEAR",
    GENERAL_ERROR: "GENERAL_ERROR",
    GENERAL_SUCCESS: "GENERAL_SUCCESS",
};
